'use client';

import { datadogRum } from '@datadog/browser-rum';

import { IdentifyUser } from './IdentifyUser';
import { environment } from './utils/environment-utils';

datadogRum.init({
  applicationId: process.env.NEXT_PUBLIC_DD_APPLICATION_ID!,
  clientToken: process.env.NEXT_PUBLIC_DD_CLIENT_TOKEN!,
  site: 'us3.datadoghq.com',
  service: 'sessions',
  env: environment.datadogEnv,
  version: process.env.NEXT_PUBLIC_SESSIONS_APP_VERSION,
  sessionSampleRate: 100,
  // All sessions are eligible for replay, but recording is buffered locally
  // and only sent when startSessionReplayRecording() is called (e.g. on error).
  // Sessions that never trigger recording are not billed.
  sessionReplaySampleRate: 100,
  startSessionReplayRecordingManually: true,
  traceContextInjection: 'sampled',
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: 'mask-user-input',
  allowedTracingUrls: [
    { match: process.env.NEXT_PUBLIC_GRAPHQL_URL!, propagatorTypes: ['tracecontext'] },
    { match: process.env.NEXT_PUBLIC_DOCS_HTTP!, propagatorTypes: ['tracecontext'] },
  ],
});

export const DatadogInit = () => {
  return <IdentifyUser />;
};
